var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBootstrapIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BULINE"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_3401_",
    style: {
      fill: "#EF9EDC"
    },
    cx: 256,
    cy: 256,
    r: 256
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1422_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6751_",
    style: {
      fill: "#C60053"
    },
    d: "M470.959,417.476h-433c-8.56,0-15.5-6.94-15.5-15.5V103.846 c0-8.56,6.94-15.5,15.5-15.5h433c8.56,0,15.5,6.94,15.5,15.5v298.129C486.459,410.536,479.52,417.476,470.959,417.476z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6750_",
    style: {
      fill: "#A4004F"
    },
    d: "M97.359,417.476h-59.4c-8.56,0-15.5-6.94-15.5-15.5v-284.13 c0-8.56,6.94-15.5,15.5-15.5h59.4c-1.01,0-1.99,0.1-2.94,0.28c-7.16,1.37-12.56,7.67-12.56,15.22v284.13c0,0.22,0,0.43,0.02,0.65 C82.209,410.886,89.019,417.476,97.359,417.476z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6749_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M454.385,402.623H276.033c-10.81,0-19.574-8.763-19.574-19.574V122.197 c0-10.81,8.763-19.574,19.574-19.574h178.352c6.668,0,12.074,5.406,12.074,12.074V390.55 C466.459,397.218,461.053,402.623,454.385,402.623z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6748_",
    style: {
      fill: "#D1D1D1"
    },
    d: "M256.459,122.196v260.85c0,10.81,8.76,19.58,19.57,19.58h20.67 c-10.81,0-19.57-8.77-19.57-19.58v-260.85c0-10.81,8.76-19.57,19.57-19.57h-20.67 C265.219,102.626,256.459,111.386,256.459,122.196z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6747_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M236.885,402.623H58.533c-6.668,0-12.074-5.406-12.074-12.074V114.697 c0-6.668,5.406-12.074,12.074-12.074h178.352c10.81,0,19.574,8.763,19.574,19.574V383.05 C256.459,393.86,247.696,402.623,236.885,402.623z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6746_",
    style: {
      fill: "#D1D1D1"
    },
    d: "M81.859,117.846v284.13c0,0.22,0,0.43,0.02,0.65h-23.35 c-6.67,0-12.07-5.41-12.07-12.08v-275.85c0-6.67,5.4-12.07,12.07-12.07h35.89C87.259,103.996,81.859,110.296,81.859,117.846z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6745_",
    style: {
      fill: "#D1D1D1"
    },
    d: "M256.459,122.196v260.85c0,10.81-8.76,19.58-19.57,19.58h-20.67 c10.81,0,19.57-8.77,19.57-19.58v-260.85c0-10.81-8.76-19.57-19.57-19.57h20.67C247.699,102.626,256.459,111.386,256.459,122.196z "
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_6744_",
    style: {
      fill: "none",
      stroke: "#354488",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 102.459,
    y1: 156.142,
    x2: 184.459,
    y2: 156.142
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_6743_",
    style: {
      fill: "none",
      stroke: "#354488",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 83.459,
    y1: 207.991,
    x2: 203.459,
    y2: 207.991
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_6742_",
    style: {
      fill: "none",
      stroke: "#354488",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 83.459,
    y1: 252.623,
    x2: 203.459,
    y2: 252.623
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_6741_",
    style: {
      fill: "none",
      stroke: "#354488",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 83.459,
    y1: 297.255,
    x2: 203.459,
    y2: 297.255
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_6740_",
    style: {
      fill: "none",
      stroke: "#354488",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 83.459,
    y1: 341.888,
    x2: 203.459,
    y2: 341.888
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6739_",
    style: {
      fill: "#273277"
    },
    d: "M447.459,143.146v221c0,5.15-4.18,9.33-9.33,9.33h-142.34 c-5.15,0-9.33-4.18-9.33-9.33v-221c0-5.16,4.18-9.34,9.33-9.34h142.34C443.279,133.806,447.459,137.986,447.459,143.146z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6679_",
    style: {
      fill: "#222C5D"
    },
    d: "M434.539,280.336c0,0-12.094,18-8.618,34.202 c1.354,6.312,1.405,12.85-0.395,19.05c-3.618,12.463-12.942,28.419-36.927,23.968c0,0-30.82,3.16-41.37,15.92h-51.44 c-5.153,0-9.33-4.177-9.33-9.33v-221c0-5.16,4.18-9.34,9.33-9.34c0,0,29.599,2.456,31.934,28.773 c0.737,8.306,6.028,15.6,13.943,18.224c6.195,2.054,13.69,1.946,20.933-4.747c0,0,38.9-15.37,58.88,22.02 C421.479,198.076,446.319,231.126,434.539,280.336z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6602_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6675_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6678_",
    style: {
      fill: "#DC4355"
    },
    d: "M407.873,308.93l9.767-8.955c1.076-0.987,0.913-2.758-0.356-3.481 c-2.374-1.352-5.238-1.558-7.775-0.596l-4.49-4.897c-1.264-1.379-3.407-1.472-4.786-0.207s-1.472,3.407-0.207,4.786l4.49,4.897 c-1.178,2.444-1.22,5.315-0.079,7.798C405.046,309.601,406.797,309.917,407.873,308.93z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6677_",
    style: {
      fill: "#A13243"
    },
    d: "M399.176,292.57c0.147-0.646,0.484-1.251,1.009-1.732 c1.381-1.266,3.522-1.171,4.786,0.207l4.491,4.898c2.537-0.964,5.401-0.756,7.775,0.596c1.27,0.722,1.433,2.491,0.356,3.478 l-2.822,2.588c1.077-0.987,0.914-2.756-0.356-3.478c-2.374-1.352-5.238-1.559-7.775-0.596l-4.491-4.898 C401.365,292.777,400.242,292.416,399.176,292.57z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6676_",
    transform: "matrix(0.7371 -0.6758 0.6758 0.7371 -99.6319 355.7188)",
    style: {
      fill: "#E27C8D"
    },
    cx: 407.343,
    cy: 305.903,
    rx: 1.951,
    ry: 1.289
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6671_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6674_",
    style: {
      fill: "#DC4355"
    },
    d: "M427.511,223.347l-6.652-11.46c-0.733-1.263-2.498-1.483-3.476-0.399 c-1.829,2.029-2.645,4.782-2.249,7.466l-5.746,3.335c-1.618,0.939-2.168,3.012-1.229,4.63c0.939,1.618,3.012,2.168,4.63,1.229 l5.746-3.335c2.135,1.675,4.93,2.332,7.599,1.75C427.56,226.252,428.244,224.61,427.511,223.347z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6673_",
    style: {
      fill: "#A13243"
    },
    d: "M409.667,228.333c-0.6-0.282-1.118-0.741-1.476-1.357 c-0.94-1.62-0.389-3.691,1.229-4.63l5.747-3.336c-0.397-2.685,0.42-5.437,2.249-7.466c0.978-1.085,2.74-0.865,3.473,0.398 l1.922,3.312c-0.733-1.263-2.496-1.484-3.473-0.398c-1.829,2.029-2.646,4.782-2.249,7.466l-5.747,3.336 C410.339,226.24,409.745,227.259,409.667,228.333z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6672_",
    transform: "matrix(0.8649 -0.502 0.502 0.8649 -54.6975 243.2491)",
    style: {
      fill: "#E27C8D"
    },
    cx: 424.441,
    cy: 223.215,
    rx: 1.289,
    ry: 1.951
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6667_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6670_",
    style: {
      fill: "#DC4355"
    },
    d: "M406.288,196.551l-11.747-6.131c-1.294-0.676-2.904,0.081-3.151,1.52 c-0.462,2.693,0.32,5.456,2.089,7.513l-3.074,5.89c-0.866,1.658-0.223,3.704,1.436,4.57c1.658,0.866,3.705,0.223,4.57-1.436 l3.074-5.89c2.699,0.275,5.413-0.664,7.358-2.582C407.882,198.98,407.583,197.227,406.288,196.551z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6669_",
    style: {
      fill: "#A13243"
    },
    d: "M393.87,210.302c-0.658,0.082-1.341-0.029-1.973-0.358 c-1.661-0.867-2.301-2.912-1.436-4.57l3.075-5.891c-1.77-2.057-2.551-4.82-2.089-7.513c0.246-1.44,1.854-2.196,3.149-1.52 l3.394,1.772c-1.295-0.676-2.902,0.08-3.149,1.52c-0.462,2.693,0.319,5.456,2.089,7.513l-3.075,5.891 C393.32,208.174,393.363,209.352,393.87,210.302z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6668_",
    transform: "matrix(0.4627 -0.8865 0.8865 0.4627 41.2635 464.2437)",
    style: {
      fill: "#E27C8D"
    },
    cx: 403.623,
    cy: 198.08,
    rx: 1.289,
    ry: 1.951
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6663_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6666_",
    style: {
      fill: "#DC4355"
    },
    d: "M306.142,284.757l7.523,10.908c0.829,1.202,2.606,1.285,3.496,0.128 c1.666-2.165,2.266-4.973,1.662-7.619l5.469-3.772c1.54-1.062,1.927-3.171,0.865-4.711s-3.171-1.927-4.711-0.865l-5.469,3.772 c-2.258-1.504-5.096-1.941-7.712-1.154C305.867,281.865,305.313,283.555,306.142,284.757z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6665_",
    style: {
      fill: "#A13243"
    },
    d: "M323.545,278.399c0.62,0.235,1.172,0.652,1.577,1.238 c1.064,1.542,0.674,3.65-0.865,4.711l-5.47,3.772c0.605,2.646,0.004,5.453-1.662,7.619c-0.89,1.158-2.665,1.075-3.494-0.127 l-2.174-3.152c0.829,1.203,2.604,1.285,3.494,0.127c1.666-2.165,2.267-4.973,1.662-7.619l5.47-3.772 C323.038,280.538,323.55,279.476,323.545,278.399z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6664_",
    transform: "matrix(0.8232 -0.5677 0.5677 0.8232 -106.9395 225.8673)",
    style: {
      fill: "#E27C8D"
    },
    cx: 309.213,
    cy: 284.65,
    rx: 1.289,
    ry: 1.951
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6659_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6662_",
    style: {
      fill: "#DC4355"
    },
    d: "M324.45,202.023l-10.467,8.125c-1.153,0.895-1.136,2.674,0.07,3.498 c2.256,1.541,5.093,1.982,7.7,1.231l4.074,5.248c1.147,1.478,3.275,1.746,4.753,0.599c1.478-1.147,1.746-3.275,0.599-4.753 l-4.074-5.248c1.374-2.34,1.651-5.197,0.718-7.765C327.322,201.586,325.603,201.128,324.45,202.023z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6661_",
    style: {
      fill: "#A13243"
    },
    d: "M331.777,219.04c-0.199,0.632-0.584,1.207-1.148,1.644 c-1.48,1.149-3.606,0.879-4.753-0.599l-4.074-5.249c-2.608,0.753-5.445,0.311-7.7-1.23c-1.206-0.824-1.224-2.6-0.07-3.496 l3.025-2.348c-1.154,0.896-1.136,2.672,0.07,3.496c2.256,1.542,5.093,1.983,7.7,1.23l4.074,5.249 C329.613,218.655,330.703,219.107,331.777,219.04z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6660_",
    transform: "matrix(0.7899 -0.6132 0.6132 0.7899 -57.541 242.1978)",
    style: {
      fill: "#E27C8D"
    },
    cx: 324.73,
    cy: 205.083,
    rx: 1.951,
    ry: 1.289
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6658_",
    style: {
      fill: "#C60053"
    },
    cx: 366.406,
    cy: 253.666,
    r: 53.417
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6657_",
    style: {
      fill: "#970A4B"
    },
    d: "M375.076,302.761c-7.644-3.286-10.424-12.735-5.835-19.675 c5.579-8.437,8.827-18.549,8.827-29.421c0-10.871-3.248-20.982-8.826-29.418c-4.589-6.941-1.809-16.391,5.836-19.676 c0.055-0.023,0.109-0.047,0.164-0.07c1.956-0.834,3.973-1.552,6.041-2.15c-4.721-1.367-9.714-2.1-14.877-2.1 c-7.422,0-14.491,1.514-20.912,4.25c-19.11,8.135-32.506,27.086-32.506,49.165s13.396,41.03,32.506,49.168 c6.421,2.736,13.49,4.25,20.912,4.25c5.163,0,10.156-0.733,14.877-2.1c-2.068-0.595-4.085-1.317-6.041-2.15 C375.187,302.809,375.132,302.785,375.076,302.761z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6653_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6656_",
    style: {
      fill: "#DC4355"
    },
    cx: 335.558,
    cy: 262.175,
    r: 10.41
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6655_",
    style: {
      fill: "#A13243"
    },
    d: "M338.351,272.207c-0.89,0.247-1.826,0.38-2.795,0.38 c-5.749,0-10.409-4.663-10.409-10.412s4.66-10.409,10.409-10.409c0.969,0,1.906,0.133,2.795,0.38 c-4.395,1.219-7.62,5.246-7.62,10.029S333.957,270.988,338.351,272.207z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6654_",
    style: {
      fill: "#E27C8D"
    },
    cx: 341.377,
    cy: 260.723,
    r: 3.026
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6649_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6652_",
    style: {
      fill: "#DC4355"
    },
    cx: 387.012,
    cy: 219.393,
    r: 10.41
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6651_",
    style: {
      fill: "#A13243"
    },
    d: "M389.806,229.425c-0.889,0.247-1.826,0.38-2.795,0.38 c-5.749,0-10.409-4.663-10.409-10.412s4.66-10.409,10.409-10.409c0.969,0,1.906,0.133,2.795,0.38 c-4.395,1.219-7.62,5.246-7.62,10.029S385.411,228.206,389.806,229.425z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6650_",
    style: {
      fill: "#E27C8D"
    },
    cx: 392.832,
    cy: 217.941,
    r: 3.026
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6645_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6648_",
    style: {
      fill: "#DC4355"
    },
    cx: 344.403,
    cy: 225.022,
    r: 10.41
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6647_",
    style: {
      fill: "#A13243"
    },
    d: "M347.197,235.054c-0.889,0.247-1.826,0.38-2.795,0.38 c-5.749,0-10.409-4.663-10.409-10.412s4.66-10.409,10.409-10.409c0.969,0,1.906,0.133,2.795,0.38 c-4.395,1.219-7.62,5.246-7.62,10.029S342.803,233.835,347.197,235.054z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6646_",
    style: {
      fill: "#E27C8D"
    },
    cx: 350.223,
    cy: 223.57,
    r: 3.026
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6641_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6644_",
    style: {
      fill: "#DC4355"
    },
    cx: 381.41,
    cy: 250.403,
    r: 7.192
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6643_",
    style: {
      fill: "#A13243"
    },
    d: "M383.34,257.333c-0.615,0.171-1.262,0.263-1.931,0.263 c-3.972,0-7.191-3.221-7.191-7.193c0-3.972,3.219-7.191,7.191-7.191c0.669,0,1.317,0.092,1.931,0.262 c-3.036,0.842-5.264,3.624-5.264,6.929C378.075,253.707,380.304,256.491,383.34,257.333z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6642_",
    style: {
      fill: "#E27C8D"
    },
    cx: 385.43,
    cy: 249.4,
    r: 2.09
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6637_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6640_",
    style: {
      fill: "#DC4355"
    },
    cx: 360.671,
    cy: 251.766,
    r: 7.192
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6639_",
    style: {
      fill: "#A13243"
    },
    d: "M362.601,258.696c-0.615,0.171-1.262,0.262-1.931,0.262 c-3.972,0-7.191-3.221-7.191-7.193s3.219-7.191,7.191-7.191c0.669,0,1.317,0.092,1.931,0.262 c-3.036,0.842-5.264,3.624-5.264,6.929S359.565,257.854,362.601,258.696z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6638_",
    style: {
      fill: "#E27C8D"
    },
    cx: 364.692,
    cy: 250.762,
    r: 2.09
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6633_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6636_",
    style: {
      fill: "#DC4355"
    },
    cx: 350.155,
    cy: 288.316,
    r: 7.192
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6635_",
    style: {
      fill: "#A13243"
    },
    d: "M352.085,295.247c-0.615,0.171-1.262,0.262-1.931,0.262 c-3.972,0-7.191-3.221-7.191-7.193c0-3.972,3.219-7.191,7.191-7.191c0.669,0,1.317,0.092,1.931,0.263 c-3.036,0.842-5.264,3.624-5.264,6.929C346.821,291.62,349.049,294.404,352.085,295.247z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6634_",
    style: {
      fill: "#E27C8D"
    },
    cx: 354.176,
    cy: 287.313,
    r: 2.09
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6632_",
    style: {
      fill: "#DC4355"
    },
    cx: 376.816,
    cy: 281.326,
    r: 8.217
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6631_",
    style: {
      fill: "#A13243"
    },
    d: "M379.021,289.243c-0.702,0.195-1.441,0.3-2.206,0.3 c-4.538,0-8.216-3.68-8.216-8.218s3.678-8.216,8.216-8.216c0.765,0,1.504,0.105,2.206,0.3c-3.468,0.962-6.014,4.14-6.014,7.916 S375.553,288.281,379.021,289.243z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6630_",
    style: {
      fill: "#E27C8D"
    },
    cx: 381.41,
    cy: 280.179,
    r: 2.388
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6629_",
    style: {
      fill: "#DC4355"
    },
    cx: 403.883,
    cy: 270.545,
    r: 8.217
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6628_",
    style: {
      fill: "#A13243"
    },
    d: "M406.089,278.463c-0.702,0.195-1.441,0.3-2.206,0.3 c-4.538,0-8.216-3.68-8.216-8.218s3.678-8.216,8.216-8.216c0.765,0,1.504,0.105,2.206,0.3c-3.468,0.962-6.014,4.14-6.014,7.916 S402.62,277.501,406.089,278.463z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6627_",
    style: {
      fill: "#E27C8D"
    },
    cx: 408.477,
    cy: 269.399,
    r: 2.388
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6626_",
    style: {
      fill: "#DC4355"
    },
    cx: 400.527,
    cy: 238.47,
    r: 8.217
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6625_",
    style: {
      fill: "#A13243"
    },
    d: "M402.732,246.388c-0.702,0.195-1.441,0.3-2.206,0.3 c-4.538,0-8.216-3.68-8.216-8.218c0-4.538,3.678-8.216,8.216-8.216c0.765,0,1.504,0.105,2.206,0.3 c-3.468,0.962-6.014,4.14-6.014,7.916C396.718,242.245,399.263,245.425,402.732,246.388z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6624_",
    style: {
      fill: "#E27C8D"
    },
    cx: 405.12,
    cy: 237.324,
    r: 2.388
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6620_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6623_",
    style: {
      fill: "#DC4355"
    },
    d: "M363.705,185.851l-12.983,2.649c-1.431,0.292-2.203,1.895-1.487,3.167 c1.34,2.381,3.689,4.032,6.359,4.514l1.328,6.509c0.374,1.833,2.163,3.016,3.996,2.642c1.833-0.374,3.016-2.163,2.642-3.996 l-1.328-6.509c2.268-1.489,3.782-3.929,4.082-6.644C366.474,186.731,365.135,185.559,363.705,185.851z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6622_",
    style: {
      fill: "#A13243"
    },
    d: "M362.738,204.353c-0.459,0.478-1.059,0.823-1.757,0.966 c-1.835,0.375-3.622-0.809-3.996-2.642l-1.328-6.511c-2.671-0.48-5.019-2.132-6.359-4.513c-0.717-1.273,0.054-2.873,1.486-3.165 l3.752-0.766c-1.431,0.292-2.202,1.892-1.486,3.165c1.34,2.381,3.688,4.033,6.359,4.513l1.328,6.511 C360.969,203.049,361.745,203.936,362.738,204.353z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6621_",
    transform: "matrix(0.9798 -0.1999 0.1999 0.9798 -30.4091 76.3033)",
    style: {
      fill: "#E27C8D"
    },
    cx: 362.601,
    cy: 188.718,
    rx: 1.951,
    ry: 1.289
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6616_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6619_",
    style: {
      fill: "#DC4355"
    },
    d: "M302.843,237.384l-1.724,13.138c-0.19,1.448,1.074,2.7,2.51,2.437 c2.688-0.491,5.014-2.174,6.339-4.542l6.587,0.864c1.855,0.243,3.556-1.063,3.799-2.918c0.243-1.855-1.063-3.556-2.918-3.799 l-6.587-0.864c-0.669-2.63-2.482-4.856-4.952-6.024C304.577,235.052,303.033,235.936,302.843,237.384z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6618_",
    style: {
      fill: "#A13243"
    },
    d: "M320.022,244.324c0.303,0.589,0.434,1.269,0.341,1.976 c-0.244,1.857-1.945,3.161-3.799,2.918l-6.588-0.864c-1.324,2.369-3.651,4.051-6.338,4.542 c-1.437,0.263-2.699-0.987-2.509-2.435l0.498-3.796c-0.19,1.449,1.072,2.698,2.509,2.435c2.688-0.491,5.014-2.173,6.338-4.542 l6.588,0.864C318.213,245.572,319.305,245.127,320.022,244.324z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6617_",
    transform: "matrix(0.1301 -0.9915 0.9915 0.1301 28.1628 510.8219)",
    style: {
      fill: "#E27C8D"
    },
    cx: 305.195,
    cy: 239.361,
    rx: 1.951,
    ry: 1.289
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6612_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6615_",
    style: {
      fill: "#DC4355"
    },
    d: "M432.686,265.782v-13.251c0-1.46-1.416-2.537-2.806-2.09 c-2.601,0.837-4.688,2.808-5.694,5.328h-6.644c-1.871,0-3.387,1.517-3.387,3.387s1.517,3.387,3.387,3.387h6.644 c1.005,2.52,3.093,4.491,5.694,5.328C431.27,268.319,432.686,267.242,432.686,265.782z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6614_",
    style: {
      fill: "#A13243"
    },
    d: "M414.751,261.136c-0.377-0.545-0.595-1.202-0.595-1.915 c0-1.873,1.517-3.387,3.387-3.387h6.645c1.004-2.521,3.093-4.492,5.693-5.328c1.39-0.448,2.804,0.627,2.804,2.088v3.829 c0-1.461-1.414-2.536-2.804-2.088c-2.601,0.837-4.689,2.807-5.693,5.328h-6.645 C416.382,259.663,415.357,260.247,414.751,261.136z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6613_",
    style: {
      fill: "#E27C8D"
    },
    cx: 430.098,
    cy: 264.127,
    rx: 1.289,
    ry: 1.951
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6608_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6611_",
    style: {
      fill: "#DC4355"
    },
    d: "M380.688,320.388l-13.206,1.083c-1.455,0.119-2.644-1.204-2.312-2.626 c0.621-2.66,2.415-4.902,4.845-6.11l-0.543-6.621c-0.153-1.864,1.234-3.5,3.099-3.653s3.5,1.234,3.653,3.099l0.543,6.621 c2.594,0.796,4.729,2.715,5.776,5.239C383.101,318.77,382.143,320.269,380.688,320.388z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6610_",
    style: {
      fill: "#A13243"
    },
    d: "M374.591,302.893c-0.574-0.331-1.246-0.495-1.957-0.436 c-1.867,0.153-3.252,1.789-3.099,3.653l0.543,6.623c-2.431,1.207-4.224,3.45-4.845,6.11c-0.333,1.422,0.855,2.743,2.311,2.624 l3.816-0.313c-1.456,0.119-2.643-1.202-2.311-2.624c0.621-2.66,2.414-4.903,4.845-6.11l-0.543-6.623 C373.257,304.639,373.754,303.57,374.591,302.893z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6609_",
    transform: "matrix(0.9967 -0.0818 0.0818 0.9967 -24.728 32.0391)",
    style: {
      fill: "#E27C8D"
    },
    cx: 378.827,
    cy: 317.944,
    rx: 1.951,
    ry: 1.289
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6603_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6607_",
    style: {
      fill: "#DC4355"
    },
    d: "M337.584,316.786l-11.617-6.373c-1.28-0.702-1.543-2.462-0.483-3.465 c1.984-1.878,4.717-2.76,7.41-2.429l3.195-5.825c0.9-1.64,2.959-2.24,4.599-1.34s2.24,2.959,1.34,4.599l-3.195,5.825 c1.726,2.094,2.45,4.872,1.933,7.555C340.489,316.765,338.864,317.488,337.584,316.786z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6605_",
    style: {
      fill: "#A13243"
    },
    d: "M342.137,298.827c-0.296-0.593-0.767-1.1-1.392-1.442 c-1.642-0.901-3.699-0.299-4.599,1.34l-3.196,5.826c-2.694-0.332-5.426,0.551-7.41,2.429c-1.061,1.004-0.799,2.76,0.482,3.463 l3.357,1.842c-1.281-0.703-1.543-2.459-0.482-3.463c1.984-1.878,4.716-2.761,7.41-2.429l3.196-5.826 C340.061,299.549,341.065,298.931,342.137,298.827z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6604_",
    transform: "matrix(0.481 -0.8767 0.8767 0.481 -99.9438 458.6144)",
    style: {
      fill: "#E27C8D"
    },
    cx: 337.378,
    cy: 313.721,
    rx: 1.289,
    ry: 1.951
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3206_",
    style: {
      fill: "#EBB141"
    },
    d: "M97.359,402.623v44.212v18.107c0,1.911,1.935,3.213,3.705,2.495l14.153-5.747 c3.329-1.352,7.054-1.352,10.383,0l14.153,5.747c1.77,0.719,3.705-0.584,3.705-2.495v-18.107v-44.212H97.359z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3102_",
    style: {
      fill: "#CE973C"
    },
    d: "M143.459,402.626v14.85h-6.99c-10.488,0-18.99,8.502-18.99,18.99v24.53 c-0.77,0.16-1.52,0.39-2.26,0.69l-14.15,5.75c-1.78,0.72-3.71-0.58-3.71-2.49v-62.32H143.459z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1423_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1463_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1466_",
    style: {
      fill: "#DC4355"
    },
    d: "M330.198,358.428l3.022-2.77c0.333-0.305,0.283-0.853-0.11-1.077 c-0.735-0.418-1.62-0.482-2.405-0.184l-1.389-1.515c-0.391-0.427-1.054-0.455-1.481-0.064s-0.455,1.054-0.064,1.481l1.389,1.515 c-0.364,0.756-0.377,1.644-0.025,2.412C329.324,358.636,329.865,358.734,330.198,358.428z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1465_",
    style: {
      fill: "#A13243"
    },
    d: "M327.508,353.367c0.045-0.2,0.15-0.387,0.312-0.536 c0.427-0.392,1.09-0.362,1.481,0.064l1.389,1.515c0.785-0.298,1.671-0.234,2.405,0.184c0.393,0.223,0.443,0.771,0.11,1.076 l-0.873,0.801c0.333-0.305,0.283-0.853-0.11-1.076c-0.734-0.418-1.62-0.482-2.405-0.184l-1.389-1.515 C328.185,353.431,327.837,353.32,327.508,353.367z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1464_",
    transform: "matrix(0.7371 -0.6758 0.6758 0.7371 -154.823 317.0364)",
    style: {
      fill: "#E27C8D"
    },
    cx: 330.034,
    cy: 357.492,
    rx: 0.604,
    ry: 0.399
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1462_",
    style: {
      fill: "#C60053"
    },
    cx: 315.693,
    cy: 344.139,
    r: 16.525
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1461_",
    style: {
      fill: "#970A4B"
    },
    d: "M318.375,359.327c-2.365-1.017-3.225-3.94-1.805-6.087 c1.726-2.61,2.731-5.739,2.731-9.102c0-3.363-1.005-6.491-2.73-9.101c-1.42-2.147-0.56-5.071,1.806-6.087 c0.017-0.007,0.034-0.014,0.051-0.022c0.605-0.258,1.229-0.48,1.869-0.665c-1.461-0.423-3.005-0.65-4.603-0.65 c-2.296,0-4.483,0.468-6.47,1.315c-5.912,2.517-10.056,8.379-10.056,15.21c0,6.83,4.144,12.693,10.056,15.211 c1.986,0.846,4.173,1.315,6.47,1.315c1.597,0,3.142-0.227,4.603-0.65c-0.64-0.184-1.264-0.407-1.869-0.665 C318.409,359.342,318.392,359.335,318.375,359.327z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1457_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1460_",
    style: {
      fill: "#DC4355"
    },
    cx: 323.868,
    cy: 344.139,
    r: 3.221
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1459_",
    style: {
      fill: "#A13243"
    },
    d: "M324.732,347.242c-0.275,0.077-0.565,0.118-0.865,0.118 c-1.779,0-3.22-1.442-3.22-3.221s1.442-3.22,3.22-3.22c0.3,0,0.59,0.041,0.865,0.118c-1.36,0.377-2.357,1.623-2.357,3.103 S323.373,346.865,324.732,347.242z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1458_",
    style: {
      fill: "#E27C8D"
    },
    cx: 325.668,
    cy: 343.69,
    r: 0.936
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1453_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1456_",
    style: {
      fill: "#DC4355"
    },
    cx: 312.84,
    cy: 335.029,
    r: 2.225
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1455_",
    style: {
      fill: "#A13243"
    },
    d: "M313.437,337.173c-0.19,0.053-0.39,0.081-0.597,0.081 c-1.229,0-2.225-0.997-2.225-2.225s0.996-2.225,2.225-2.225c0.207,0,0.407,0.028,0.597,0.081 c-0.939,0.261-1.629,1.121-1.629,2.143S312.498,336.912,313.437,337.173z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1454_",
    style: {
      fill: "#E27C8D"
    },
    cx: 314.084,
    cy: 334.718,
    r: 0.647
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1449_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1452_",
    style: {
      fill: "#DC4355"
    },
    cx: 309.731,
    cy: 352.111,
    r: 2.225
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1451_",
    style: {
      fill: "#A13243"
    },
    d: "M310.329,354.255c-0.19,0.053-0.39,0.081-0.597,0.081 c-1.229,0-2.225-0.997-2.225-2.225c0-1.229,0.996-2.225,2.225-2.225c0.207,0,0.407,0.028,0.597,0.081 c-0.939,0.261-1.629,1.121-1.629,2.143C308.7,353.134,309.389,353.995,310.329,354.255z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1450_",
    style: {
      fill: "#E27C8D"
    },
    cx: 310.975,
    cy: 351.801,
    r: 0.647
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1445_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1448_",
    style: {
      fill: "#DC4355"
    },
    d: "M314.857,323.159l-4.017,0.82c-0.443,0.09-0.681,0.586-0.46,0.98 c0.414,0.737,1.141,1.247,1.967,1.396l0.411,2.014c0.116,0.567,0.669,0.933,1.236,0.817c0.567-0.116,0.933-0.669,0.817-1.236 l-0.411-2.014c0.702-0.461,1.17-1.215,1.263-2.055C315.714,323.432,315.3,323.069,314.857,323.159z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1447_",
    style: {
      fill: "#A13243"
    },
    d: "M314.558,328.883c-0.142,0.148-0.327,0.255-0.544,0.299 c-0.568,0.116-1.121-0.25-1.236-0.817l-0.411-2.014c-0.826-0.148-1.553-0.66-1.967-1.396c-0.222-0.394,0.017-0.889,0.46-0.979 l1.161-0.237c-0.443,0.09-0.681,0.585-0.46,0.979c0.414,0.737,1.141,1.248,1.967,1.396l0.411,2.014 C314.011,328.48,314.251,328.754,314.558,328.883z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1446_",
    transform: "matrix(0.9798 -0.1999 0.1999 0.9798 -58.4355 69.422)",
    style: {
      fill: "#E27C8D"
    },
    cx: 314.516,
    cy: 324.046,
    rx: 0.604,
    ry: 0.399
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1436_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1444_",
    style: {
      fill: "#DC4355"
    },
    d: "M298.43,333.521l-2.143,3.494c-0.236,0.385-0.037,0.898,0.402,1.005 c0.821,0.2,1.691,0.018,2.363-0.484l1.752,1.075c0.493,0.303,1.139,0.148,1.441-0.345c0.303-0.493,0.148-1.139-0.345-1.441 l-1.752-1.075c0.143-0.827-0.089-1.685-0.64-2.326C299.214,333.081,298.667,333.136,298.43,333.521z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1442_",
    style: {
      fill: "#A13243"
    },
    d: "M302.409,337.647c0.011,0.205-0.037,0.413-0.153,0.601 c-0.303,0.494-0.948,0.648-1.441,0.345l-1.752-1.075c-0.673,0.502-1.542,0.684-2.363,0.484 c-0.439-0.107-0.638-0.619-0.402-1.004l0.619-1.01c-0.236,0.385-0.037,0.897,0.402,1.004c0.821,0.2,1.691,0.018,2.363-0.484 l1.752,1.075C301.74,337.772,302.105,337.784,302.409,337.647z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1441_",
    transform: "matrix(0.5228 -0.8524 0.8524 0.5228 -142.4349 414.2986)",
    style: {
      fill: "#E27C8D"
    },
    cx: 298.845,
    cy: 334.376,
    rx: 0.604,
    ry: 0.399
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1432_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1435_",
    style: {
      fill: "#DC4355"
    },
    d: "M335.221,336.067l-2.163-3.482c-0.238-0.384-0.786-0.436-1.079-0.091 c-0.547,0.644-0.774,1.503-0.627,2.33l-1.746,1.085c-0.492,0.305-0.643,0.951-0.337,1.443c0.305,0.492,0.951,0.643,1.443,0.337 l1.746-1.084c0.676,0.498,1.546,0.675,2.366,0.471C335.263,336.965,335.46,336.451,335.221,336.067z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1434_",
    style: {
      fill: "#A13243"
    },
    d: "M329.75,337.774c-0.188-0.082-0.353-0.219-0.469-0.406 c-0.306-0.492-0.154-1.138,0.337-1.443l1.746-1.085c-0.148-0.827,0.079-1.685,0.626-2.33c0.292-0.345,0.839-0.293,1.078,0.091 l0.625,1.006c-0.238-0.384-0.786-0.436-1.078-0.091c-0.547,0.644-0.774,1.503-0.626,2.33l-1.746,1.085 C329.938,337.12,329.764,337.441,329.75,337.774z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1433_",
    transform: "matrix(0.8495 -0.5277 0.5277 0.8495 -126.9988 226.9674)",
    style: {
      fill: "#E27C8D"
    },
    cx: 334.271,
    cy: 336.055,
    rx: 0.399,
    ry: 0.604
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1428_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1431_",
    style: {
      fill: "#DC4355"
    },
    d: "M320.111,364.781l-4.086,0.335c-0.45,0.037-0.818-0.372-0.715-0.812 c0.192-0.823,0.747-1.517,1.499-1.89l-0.168-2.048c-0.047-0.577,0.382-1.083,0.959-1.13c0.577-0.047,1.083,0.382,1.13,0.959 l0.168,2.048c0.802,0.246,1.463,0.84,1.787,1.621C320.858,364.28,320.561,364.744,320.111,364.781z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1430_",
    style: {
      fill: "#A13243"
    },
    d: "M318.225,359.368c-0.178-0.102-0.386-0.153-0.605-0.135 c-0.578,0.047-1.006,0.553-0.959,1.13l0.168,2.049c-0.752,0.373-1.307,1.067-1.499,1.89c-0.103,0.44,0.264,0.849,0.715,0.812 l1.181-0.097c-0.45,0.037-0.818-0.372-0.715-0.812c0.192-0.823,0.747-1.517,1.499-1.89l-0.168-2.049 C317.812,359.908,317.966,359.578,318.225,359.368z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1429_",
    transform: "matrix(0.9967 -0.0818 0.0818 0.9967 -28.6943 27.3455)",
    style: {
      fill: "#E27C8D"
    },
    cx: 319.535,
    cy: 364.024,
    rx: 0.604,
    ry: 0.399
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1424_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1427_",
    style: {
      fill: "#DC4355"
    },
    d: "M299.386,358.097l-2.27-3.414c-0.25-0.376-0.07-0.896,0.365-1.019 c0.813-0.23,1.689-0.08,2.379,0.397l1.712-1.138c0.482-0.32,1.132-0.189,1.453,0.292c0.32,0.482,0.189,1.132-0.292,1.453 l-1.712,1.138c0.173,0.821-0.028,1.687-0.554,2.348C300.186,358.508,299.636,358.473,299.386,358.097z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1426_",
    style: {
      fill: "#A13243"
    },
    d: "M303.211,353.828c0.004-0.205-0.053-0.411-0.175-0.595 c-0.321-0.483-0.971-0.613-1.453-0.292l-1.712,1.138c-0.691-0.477-1.566-0.627-2.379-0.397 c-0.435,0.123-0.615,0.642-0.365,1.018l0.656,0.986c-0.25-0.376-0.07-0.896,0.365-1.018c0.813-0.23,1.689-0.08,2.379,0.397 l1.712-1.138C302.538,353.728,302.902,353.703,303.211,353.828z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1425_",
    transform: "matrix(0.8327 -0.5537 0.5537 0.8327 -147.6428 225.7153)",
    style: {
      fill: "#E27C8D"
    },
    cx: 299.77,
    cy: 357.228,
    rx: 0.399,
    ry: 0.604
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1525_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1581_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1584_",
    style: {
      fill: "#DC4355"
    },
    d: "M343.555,179.116l3.022-2.77c0.333-0.305,0.283-0.853-0.11-1.077 c-0.735-0.418-1.62-0.482-2.405-0.184l-1.389-1.515c-0.391-0.427-1.054-0.455-1.481-0.064s-0.455,1.054-0.064,1.481l1.389,1.515 c-0.364,0.756-0.377,1.644-0.025,2.412C342.681,179.324,343.222,179.421,343.555,179.116z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1583_",
    style: {
      fill: "#A13243"
    },
    d: "M340.865,174.055c0.045-0.2,0.15-0.387,0.312-0.536 c0.427-0.392,1.09-0.362,1.481,0.064l1.389,1.515c0.785-0.298,1.671-0.234,2.405,0.184c0.393,0.223,0.443,0.771,0.11,1.076 l-0.873,0.801c0.333-0.305,0.283-0.853-0.11-1.076c-0.734-0.418-1.62-0.482-2.405-0.184l-1.389-1.515 C341.542,174.119,341.194,174.007,340.865,174.055z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1582_",
    transform: "matrix(0.7371 -0.6758 0.6758 0.7371 -30.1293 278.9171)",
    style: {
      fill: "#E27C8D"
    },
    cx: 343.391,
    cy: 178.18,
    rx: 0.604,
    ry: 0.399
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1580_",
    style: {
      fill: "#C60053"
    },
    cx: 329.05,
    cy: 164.827,
    r: 16.525
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1579_",
    style: {
      fill: "#970A4B"
    },
    d: "M331.732,180.015c-2.365-1.017-3.225-3.94-1.805-6.087 c1.726-2.61,2.731-5.739,2.731-9.102c0-3.363-1.005-6.491-2.73-9.101c-1.42-2.147-0.56-5.071,1.806-6.087 c0.017-0.007,0.034-0.014,0.051-0.022c0.605-0.258,1.229-0.48,1.869-0.665c-1.461-0.423-3.005-0.65-4.603-0.65 c-2.296,0-4.483,0.468-6.47,1.315c-5.912,2.517-10.056,8.379-10.056,15.21c0,6.83,4.144,12.693,10.056,15.211 c1.986,0.847,4.173,1.315,6.47,1.315c1.597,0,3.142-0.227,4.603-0.65c-0.64-0.184-1.264-0.407-1.869-0.665 C331.766,180.03,331.749,180.022,331.732,180.015z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1575_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1578_",
    style: {
      fill: "#DC4355"
    },
    cx: 337.225,
    cy: 164.827,
    r: 3.221
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1577_",
    style: {
      fill: "#A13243"
    },
    d: "M338.089,167.93c-0.275,0.077-0.565,0.118-0.865,0.118 c-1.779,0-3.22-1.442-3.22-3.221c0-1.779,1.442-3.22,3.22-3.22c0.3,0,0.59,0.041,0.865,0.118 c-1.36,0.377-2.357,1.623-2.357,3.103C335.732,166.306,336.73,167.553,338.089,167.93z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1576_",
    style: {
      fill: "#E27C8D"
    },
    cx: 339.025,
    cy: 164.377,
    r: 0.936
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1571_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1574_",
    style: {
      fill: "#DC4355"
    },
    cx: 326.197,
    cy: 155.716,
    r: 2.225
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1573_",
    style: {
      fill: "#A13243"
    },
    d: "M326.794,157.861c-0.19,0.053-0.39,0.081-0.597,0.081 c-1.229,0-2.225-0.997-2.225-2.225c0-1.229,0.996-2.225,2.225-2.225c0.207,0,0.407,0.028,0.597,0.081 c-0.939,0.261-1.629,1.121-1.629,2.143C325.166,156.739,325.855,157.6,326.794,157.861z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1572_",
    style: {
      fill: "#E27C8D"
    },
    cx: 327.441,
    cy: 155.406,
    r: 0.647
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1567_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1570_",
    style: {
      fill: "#DC4355"
    },
    cx: 323.088,
    cy: 172.799,
    r: 2.225
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1569_",
    style: {
      fill: "#A13243"
    },
    d: "M323.686,174.943c-0.19,0.053-0.39,0.081-0.597,0.081 c-1.229,0-2.225-0.997-2.225-2.225c0-1.229,0.996-2.225,2.225-2.225c0.207,0,0.407,0.028,0.597,0.081 c-0.939,0.261-1.629,1.121-1.629,2.143C322.057,173.821,322.746,174.683,323.686,174.943z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1568_",
    style: {
      fill: "#E27C8D"
    },
    cx: 324.332,
    cy: 172.489,
    r: 0.647
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1563_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1566_",
    style: {
      fill: "#DC4355"
    },
    d: "M328.214,143.847l-4.017,0.82c-0.443,0.09-0.681,0.586-0.46,0.98 c0.414,0.737,1.141,1.247,1.967,1.396l0.411,2.014c0.116,0.567,0.669,0.933,1.236,0.817c0.567-0.116,0.933-0.669,0.817-1.236 l-0.411-2.014c0.702-0.461,1.17-1.215,1.263-2.055C329.071,144.119,328.657,143.757,328.214,143.847z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1565_",
    style: {
      fill: "#A13243"
    },
    d: "M327.915,149.571c-0.142,0.148-0.327,0.255-0.544,0.299 c-0.568,0.116-1.121-0.25-1.236-0.817l-0.411-2.014c-0.826-0.149-1.553-0.66-1.967-1.396c-0.222-0.394,0.017-0.889,0.46-0.979 l1.161-0.237c-0.443,0.09-0.681,0.585-0.46,0.979c0.414,0.737,1.141,1.248,1.967,1.396l0.411,2.014 C327.368,149.167,327.608,149.442,327.915,149.571z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1564_",
    transform: "matrix(0.9798 -0.1999 0.1999 0.9798 -22.3167 68.4722)",
    style: {
      fill: "#E27C8D"
    },
    cx: 327.873,
    cy: 144.734,
    rx: 0.604,
    ry: 0.399
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1558_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1561_",
    style: {
      fill: "#DC4355"
    },
    d: "M311.787,154.209l-2.143,3.494c-0.236,0.385-0.037,0.898,0.402,1.005 c0.821,0.2,1.691,0.018,2.363-0.484l1.752,1.075c0.493,0.303,1.139,0.148,1.441-0.345c0.303-0.493,0.148-1.139-0.345-1.441 l-1.752-1.075c0.143-0.827-0.089-1.685-0.64-2.326C312.571,153.769,312.024,153.824,311.787,154.209z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1560_",
    style: {
      fill: "#A13243"
    },
    d: "M315.766,158.335c0.011,0.205-0.037,0.413-0.153,0.601 c-0.303,0.494-0.948,0.648-1.441,0.345l-1.752-1.075c-0.673,0.502-1.542,0.684-2.363,0.484 c-0.439-0.107-0.638-0.619-0.402-1.004l0.619-1.01c-0.236,0.385-0.037,0.897,0.402,1.004c0.821,0.2,1.691,0.018,2.363-0.484 l1.752,1.075C315.097,158.459,315.462,158.471,315.766,158.335z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1559_",
    transform: "matrix(0.5228 -0.8524 0.8524 0.5228 16.7905 340.123)",
    style: {
      fill: "#E27C8D"
    },
    cx: 312.202,
    cy: 155.064,
    rx: 0.604,
    ry: 0.399
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1554_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1557_",
    style: {
      fill: "#DC4355"
    },
    d: "M348.578,156.755l-2.163-3.482c-0.238-0.384-0.786-0.436-1.079-0.091 c-0.547,0.644-0.774,1.503-0.627,2.33l-1.746,1.084c-0.492,0.305-0.643,0.951-0.337,1.443c0.305,0.492,0.951,0.643,1.443,0.337 l1.746-1.084c0.676,0.498,1.546,0.675,2.366,0.471C348.62,157.653,348.817,157.138,348.578,156.755z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1556_",
    style: {
      fill: "#A13243"
    },
    d: "M343.107,158.462c-0.188-0.082-0.353-0.219-0.469-0.406 c-0.306-0.492-0.154-1.138,0.337-1.443l1.746-1.085c-0.148-0.827,0.079-1.685,0.626-2.33c0.292-0.345,0.839-0.293,1.078,0.091 l0.625,1.006c-0.238-0.384-0.786-0.436-1.078-0.091c-0.547,0.644-0.774,1.503-0.626,2.33l-1.746,1.085 C343.295,157.808,343.121,158.129,343.107,158.462z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1555_",
    transform: "matrix(0.8495 -0.5277 0.5277 0.8495 -30.3738 207.0218)",
    style: {
      fill: "#E27C8D"
    },
    cx: 347.628,
    cy: 156.742,
    rx: 0.399,
    ry: 0.604
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1549_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1553_",
    style: {
      fill: "#DC4355"
    },
    d: "M333.468,185.468l-4.086,0.335c-0.45,0.037-0.818-0.372-0.715-0.812 c0.192-0.823,0.747-1.517,1.499-1.89l-0.168-2.048c-0.047-0.577,0.382-1.083,0.959-1.13c0.577-0.047,1.083,0.382,1.13,0.959 l0.168,2.048c0.802,0.246,1.463,0.84,1.787,1.621C334.215,184.968,333.918,185.431,333.468,185.468z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1551_",
    style: {
      fill: "#A13243"
    },
    d: "M331.582,180.056c-0.178-0.102-0.386-0.153-0.605-0.135 c-0.578,0.047-1.006,0.553-0.959,1.13l0.168,2.049c-0.752,0.373-1.307,1.067-1.499,1.89c-0.103,0.44,0.264,0.849,0.715,0.812 l1.181-0.097c-0.45,0.037-0.818-0.372-0.715-0.812c0.192-0.823,0.747-1.517,1.499-1.89l-0.168-2.049 C331.169,180.596,331.323,180.265,331.582,180.056z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1550_",
    transform: "matrix(0.9967 -0.0818 0.0818 0.9967 -13.9882 27.8372)",
    style: {
      fill: "#E27C8D"
    },
    cx: 332.892,
    cy: 184.712,
    rx: 0.604,
    ry: 0.399
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1545_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1548_",
    style: {
      fill: "#DC4355"
    },
    d: "M312.743,178.785l-2.27-3.414c-0.25-0.376-0.07-0.896,0.365-1.019 c0.813-0.23,1.689-0.08,2.379,0.397l1.712-1.138c0.482-0.32,1.132-0.189,1.453,0.292c0.32,0.482,0.189,1.132-0.292,1.453 l-1.712,1.138c0.173,0.821-0.028,1.687-0.554,2.348C313.543,179.196,312.993,179.161,312.743,178.785z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1547_",
    style: {
      fill: "#A13243"
    },
    d: "M316.568,174.516c0.004-0.205-0.053-0.411-0.175-0.595 c-0.321-0.483-0.971-0.613-1.453-0.292l-1.712,1.138c-0.691-0.478-1.566-0.627-2.379-0.398 c-0.435,0.123-0.615,0.642-0.365,1.018l0.656,0.986c-0.25-0.376-0.07-0.895,0.365-1.018c0.813-0.23,1.689-0.08,2.379,0.398 l1.712-1.138C315.895,174.416,316.259,174.391,316.568,174.516z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1546_",
    transform: "matrix(0.8327 -0.5537 0.5537 0.8327 -46.1321 203.1201)",
    style: {
      fill: "#E27C8D"
    },
    cx: 313.127,
    cy: 177.915,
    rx: 0.399,
    ry: 0.604
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6580_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6694_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6697_",
    style: {
      fill: "#DC4355"
    },
    d: "M428.145,175.281l1.784-1.636c0.197-0.18,0.167-0.504-0.065-0.636 c-0.434-0.247-0.957-0.285-1.42-0.109l-0.82-0.895c-0.231-0.252-0.622-0.269-0.874-0.038c-0.252,0.231-0.269,0.622-0.038,0.874 l0.82,0.895c-0.215,0.447-0.223,0.971-0.014,1.424C427.629,175.403,427.948,175.461,428.145,175.281z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6696_",
    style: {
      fill: "#A13243"
    },
    d: "M426.556,172.292c0.027-0.118,0.088-0.228,0.184-0.316 c0.252-0.231,0.643-0.214,0.874,0.038l0.82,0.895c0.463-0.176,0.987-0.138,1.42,0.109c0.232,0.132,0.262,0.455,0.065,0.635 l-0.516,0.473c0.197-0.18,0.167-0.503-0.065-0.635c-0.434-0.247-0.957-0.285-1.42-0.109l-0.82-0.895 C426.956,172.33,426.751,172.264,426.556,172.292z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6695_",
    transform: "matrix(0.7371 -0.6758 0.6758 0.7371 -5.5379 335.2219)",
    style: {
      fill: "#E27C8D"
    },
    cx: 428.048,
    cy: 174.728,
    rx: 0.356,
    ry: 0.235
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6693_",
    style: {
      fill: "#C60053"
    },
    cx: 419.58,
    cy: 166.843,
    r: 9.758
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6692_",
    style: {
      fill: "#970A4B"
    },
    d: "M421.164,175.812c-1.396-0.6-1.904-2.326-1.066-3.594 c1.019-1.541,1.612-3.388,1.612-5.374c0-1.986-0.593-3.833-1.612-5.374c-0.838-1.268-0.33-2.994,1.066-3.594 c0.01-0.004,0.02-0.009,0.03-0.013c0.357-0.152,0.726-0.284,1.104-0.393c-0.862-0.25-1.774-0.384-2.718-0.384 c-1.356,0-2.647,0.277-3.82,0.776c-3.491,1.486-5.938,4.948-5.938,8.981s2.447,7.495,5.938,8.982 c1.173,0.5,2.464,0.776,3.82,0.776c0.943,0,1.855-0.134,2.718-0.384c-0.378-0.109-0.746-0.241-1.104-0.393 C421.184,175.82,421.174,175.816,421.164,175.812z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6688_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6691_",
    style: {
      fill: "#DC4355"
    },
    cx: 424.407,
    cy: 166.843,
    r: 1.902
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6690_",
    style: {
      fill: "#A13243"
    },
    d: "M424.918,168.676c-0.162,0.045-0.334,0.069-0.511,0.069 c-1.05,0-1.901-0.852-1.901-1.902s0.851-1.901,1.901-1.901c0.177,0,0.348,0.024,0.511,0.069 c-0.803,0.223-1.392,0.958-1.392,1.832S424.115,168.453,424.918,168.676z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6689_",
    style: {
      fill: "#E27C8D"
    },
    cx: 425.47,
    cy: 166.578,
    r: 0.553
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6684_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6687_",
    style: {
      fill: "#DC4355"
    },
    cx: 417.896,
    cy: 161.464,
    r: 1.314
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6686_",
    style: {
      fill: "#A13243"
    },
    d: "M418.248,162.73c-0.112,0.031-0.23,0.048-0.353,0.048 c-0.726,0-1.314-0.588-1.314-1.314s0.588-1.314,1.314-1.314c0.122,0,0.241,0.017,0.353,0.048 c-0.555,0.154-0.962,0.662-0.962,1.266C417.287,162.068,417.694,162.576,418.248,162.73z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6685_",
    style: {
      fill: "#E27C8D"
    },
    cx: 418.63,
    cy: 161.281,
    r: 0.382
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6680_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6683_",
    style: {
      fill: "#DC4355"
    },
    cx: 416.06,
    cy: 171.551,
    r: 1.314
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6682_",
    style: {
      fill: "#A13243"
    },
    d: "M416.413,172.817c-0.112,0.031-0.23,0.048-0.353,0.048 c-0.726,0-1.314-0.588-1.314-1.314c0-0.726,0.588-1.314,1.314-1.314c0.122,0,0.241,0.017,0.353,0.048 c-0.555,0.154-0.962,0.662-0.962,1.266C415.451,172.155,415.858,172.663,416.413,172.817z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_6681_",
    style: {
      fill: "#E27C8D"
    },
    cx: 416.794,
    cy: 171.368,
    r: 0.382
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6598_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6601_",
    style: {
      fill: "#DC4355"
    },
    d: "M419.087,154.455l-2.372,0.484c-0.261,0.053-0.402,0.346-0.272,0.579 c0.245,0.435,0.674,0.737,1.162,0.825l0.243,1.189c0.068,0.335,0.395,0.551,0.73,0.483c0.335-0.068,0.551-0.395,0.483-0.73 l-0.243-1.189c0.414-0.272,0.691-0.718,0.746-1.214C419.592,154.616,419.348,154.402,419.087,154.455z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6600_",
    style: {
      fill: "#A13243"
    },
    d: "M418.91,157.835c-0.084,0.087-0.193,0.15-0.321,0.176 c-0.335,0.068-0.662-0.148-0.73-0.483l-0.243-1.189c-0.488-0.088-0.917-0.389-1.162-0.824c-0.131-0.232,0.01-0.525,0.271-0.578 l0.685-0.14c-0.262,0.053-0.402,0.346-0.271,0.578c0.245,0.435,0.674,0.737,1.162,0.824l0.243,1.189 C418.587,157.597,418.729,157.759,418.91,157.835z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6599_",
    transform: "matrix(0.9798 -0.1999 0.1999 0.9798 -22.5275 86.8748)",
    style: {
      fill: "#E27C8D"
    },
    cx: 418.885,
    cy: 154.979,
    rx: 0.356,
    ry: 0.235
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6594_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6597_",
    style: {
      fill: "#DC4355"
    },
    d: "M409.387,160.574l-1.266,2.063c-0.139,0.227-0.022,0.53,0.237,0.593 c0.485,0.118,0.998,0.011,1.396-0.286l1.035,0.635c0.291,0.179,0.672,0.087,0.851-0.204c0.179-0.291,0.087-0.672-0.204-0.851 l-1.035-0.635c0.084-0.488-0.053-0.995-0.378-1.373C409.85,160.314,409.526,160.346,409.387,160.574z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6596_",
    style: {
      fill: "#A13243"
    },
    d: "M411.736,163.01c0.007,0.121-0.022,0.244-0.09,0.355 c-0.179,0.292-0.56,0.383-0.851,0.204l-1.035-0.635c-0.397,0.297-0.911,0.404-1.395,0.286c-0.259-0.063-0.377-0.366-0.237-0.593 l0.366-0.596c-0.14,0.227-0.022,0.53,0.237,0.593c0.485,0.118,0.998,0.011,1.395-0.286l1.035,0.635 C411.341,163.084,411.557,163.091,411.736,163.01z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6595_",
    transform: "matrix(0.5228 -0.8524 0.8524 0.5228 58.1533 426.0454)",
    style: {
      fill: "#E27C8D"
    },
    cx: 409.632,
    cy: 161.079,
    rx: 0.356,
    ry: 0.235
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6590_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6593_",
    style: {
      fill: "#DC4355"
    },
    d: "M431.111,162.077l-1.277-2.056c-0.141-0.227-0.464-0.257-0.637-0.054 c-0.323,0.381-0.457,0.888-0.37,1.376l-1.031,0.64c-0.29,0.18-0.379,0.562-0.199,0.852c0.18,0.29,0.562,0.379,0.852,0.199 l1.031-0.64c0.399,0.294,0.913,0.399,1.397,0.278C431.136,162.607,431.252,162.304,431.111,162.077z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6592_",
    style: {
      fill: "#A13243"
    },
    d: "M427.88,163.085c-0.111-0.048-0.208-0.129-0.277-0.24 c-0.181-0.291-0.091-0.672,0.199-0.852l1.031-0.64c-0.087-0.488,0.047-0.995,0.37-1.376c0.173-0.203,0.496-0.173,0.636,0.054 l0.369,0.594c-0.141-0.227-0.464-0.257-0.636-0.054c-0.323,0.38-0.457,0.888-0.37,1.376l-1.031,0.64 C427.991,162.699,427.889,162.888,427.88,163.085z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6591_",
    transform: "matrix(0.8495 -0.5277 0.5277 0.8495 -20.7019 251.5776)",
    style: {
      fill: "#E27C8D"
    },
    cx: 430.55,
    cy: 162.07,
    rx: 0.235,
    ry: 0.356
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6585_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6589_",
    style: {
      fill: "#DC4355"
    },
    d: "M422.189,179.032l-2.412,0.198c-0.266,0.022-0.483-0.22-0.422-0.48 c0.113-0.486,0.441-0.896,0.885-1.116l-0.099-1.21c-0.028-0.341,0.226-0.639,0.566-0.667c0.341-0.028,0.639,0.226,0.667,0.566 l0.099,1.21c0.474,0.145,0.864,0.496,1.055,0.957C422.63,178.736,422.455,179.01,422.189,179.032z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6588_",
    style: {
      fill: "#A13243"
    },
    d: "M421.075,175.836c-0.105-0.061-0.228-0.09-0.357-0.08 c-0.341,0.028-0.594,0.327-0.566,0.667l0.099,1.21c-0.444,0.221-0.772,0.63-0.885,1.116c-0.061,0.26,0.156,0.501,0.422,0.479 l0.697-0.057c-0.266,0.022-0.483-0.22-0.422-0.479c0.113-0.486,0.441-0.896,0.885-1.116l-0.099-1.21 C420.831,176.155,420.922,175.96,421.075,175.836z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6586_",
    transform: "matrix(0.9967 -0.0818 0.0818 0.9967 -13.1894 35.0902)",
    style: {
      fill: "#E27C8D"
    },
    cx: 421.849,
    cy: 178.585,
    rx: 0.356,
    ry: 0.235
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6581_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6584_",
    style: {
      fill: "#DC4355"
    },
    d: "M409.951,175.085l-1.34-2.016c-0.148-0.222-0.041-0.529,0.215-0.602 c0.48-0.136,0.997-0.047,1.405,0.235l1.011-0.672c0.285-0.189,0.669-0.112,0.858,0.173c0.189,0.285,0.112,0.669-0.173,0.858 l-1.011,0.672c0.102,0.485-0.016,0.996-0.327,1.386C410.423,175.328,410.099,175.308,409.951,175.085z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6583_",
    style: {
      fill: "#A13243"
    },
    d: "M412.21,172.565c0.002-0.121-0.031-0.243-0.103-0.351 c-0.189-0.285-0.573-0.362-0.858-0.173l-1.011,0.672c-0.408-0.282-0.925-0.37-1.405-0.235c-0.257,0.072-0.363,0.379-0.215,0.601 l0.387,0.582c-0.148-0.222-0.041-0.529,0.215-0.601c0.48-0.136,0.997-0.047,1.405,0.235l1.011-0.672 C411.813,172.506,412.028,172.491,412.21,172.565z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_6582_",
    transform: "matrix(0.8327 -0.5537 0.5537 0.8327 -28.049 256.2935)",
    style: {
      fill: "#E27C8D"
    },
    cx: 410.178,
    cy: 174.572,
    rx: 0.235,
    ry: 0.356
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrapIcon);
export default __webpack_public_path__ + "static/media/bootstrap-icon.de6127e68aad870b95810c9d3a80777a.svg";
export { ForwardRef as ReactComponent };